export const TrashIcon = ({
  width = 24,
  height = 24,
  fill = "#000000",
  className,
}: {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M17.999 3h-12c-1.103 0-2 .897-2 2v2c0 .266.105.52.293.707l.293.293h1.414l.293-.293c.188-.187.293-.441.293-.707v-1h10v1c0 .266.105.52.293.707l.293.293h1.414l.293-.293c.188-.187.293-.441.293-.707v-2c0-1.103-.897-2-2-2z"></path>
        <path d="M6.999 7v13c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-13h-10z"></path>
        <path d="M14.999 10h-1v9h1v-9z"></path>
        <path d="M10.999 10h-1v9h1v-9z"></path>
      </g>
    </svg>
  );
};
